import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconBellFilled: React.FC = () => (
    <Icon viewBox="0 0 24 24" fill="none">
        <path
            d="M21,17.5A1.5,1.5,0,0,1,19.5,16V11.14A8,8,0,0,0,13,3.07V1a1,1,0,0,0-2,0V3.07a8,8,0,0,0-6.5,8.07V16A1.5,1.5,0,0,1,3,17.5a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
            fill="currentColor"
        />
        <path
            d="M14.24,21H9.76a.25.25,0,0,0-.24.22,2.64,2.64,0,0,0,0,.28,2.5,2.5,0,0,0,5,0,2.64,2.64,0,0,0,0-.28A.25.25,0,0,0,14.24,21Z"
            fill="currentColor"
        />
    </Icon>
);
